import React, {memo, useCallback, useEffect, useMemo, useState} from "react";
import {PasswordContainer} from "../../../../components/PasswordContainer";
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer";
import {RangeComponent} from "../../../../components/Range/RangeComponent";
import iconSound from "../../../../assets/images/icons/settings/sound.png";
import iconSoundOff from "../../../../assets/images/icons/settings/soundoff.png";
import microphoneOn from "../../../../assets/images/icons/settings/microphoneon.png";
import microphoneOff from "../../../../assets/images/icons/settings/microphoneoff.png";
import playSound from "../../../../assets/images/icons/media/play-sound.png";
import saveSound from "../../../../assets/images/icons/media/save-sound.png";
import "./index.scss";
import {useDispatch, useSelector} from "react-redux";
import {SoundState} from "../../../../store/control/state";
import {useRPC} from "../../../../hooks/rpc";
import {setSoundStateAction} from "../../../../store/control/actions";
import {useMessage} from "../../../../hooks/message";
import {useLocalization} from "../../../../hooks/localization";
import {SettingSelectComponent} from "../../../../components/Settings/SettingSelectComponent";
import {SelectItem} from "../../../../components/Select";
import {SettingCheckBoxComponent} from "../../../../components/Settings/SettingCheckboxComponent";

export const SoundEditScreen = memo(function SoundEditScreen() {
    const {t} = useLocalization();
    const [rpc] = useRPC();
    const dispatch = useDispatch();
    const {success, failure} = useMessage();
    const sound = useSelector((state) => state.control.sound);

    const incoming_call_outer_panel = useMemo<SelectItem<number>[]>(
        () => [
            {
                value: 5,
                label: t("bell_0"),
            },
            {
                value: 6,
                label: t("bell_1"),
            },
            {
                value: 7,
                label: t("bell_2"),
            }, {
                value: 8,
                label: t("bell_3"),
            },
            {
                value: 9,
                label: t("bell_4"),
            },
        ],
        [t]
    );

    const incoming_call_flat_front = useMemo<SelectItem<number>[]>(
        () => [
            {
                value: 20,
                label: t("sip_bell_0"),
            },
            {
                value: 21,
                label: t("sip_bell_1"),
            },
            {
                value: 22,
                label: t("sip_bell_2"),
            },
            {
                value: 23,
                label: t("sip_bell_3"),
            },
            {
                value: 24,
                label: t("sip_bell_4"),
            },
            {
                value: 25,
                label: t("sip_bell_5"),
            },
            {
                value: 26,
                label: t("sip_bell_6"),
            },
        ],
        [t]
    );

    const [soundReverse, setSoundReverse] = useState(false);
    const setSoundReverseCheckbox = useCallback(() => {
        setSoundReverse(!soundReverse);
        sound.click_sound = soundReverse
        rpc.SetClickSound(soundReverse)
    }, [soundReverse]);

    const [selectedSound, setSelectedSound] = useState<SelectItem<number>>(
        incoming_call_flat_front.find((heatingOption) => heatingOption.value)
    );
    const handlerSipSave = () => {
        rpc.IncomingOuterPanelRing(selectedSound.value, "save")
            .then(() => {
                success(t('successfully_saved'));
            })
            .catch(failure);
    };
    const handlerSipPlay = () => {
        rpc.IncomingOuterPanelRing(selectedSound.value, "play")
            .then(() => {

            })
            .catch(failure);
    };
    const [selectedSound2, setSelectedSound2] = useState<SelectItem<number>>(
        incoming_call_outer_panel.find((heatingOption) => heatingOption.value)
    );
    const handlerBellSave = () => {
        rpc.IncomingFlatFrontRing(selectedSound2.value, "save")
            .then(() => {
                success(t('successfully_saved'));
            })
            .catch(failure);
    };
    const handlerBellPlay = () => {
        rpc.IncomingFlatFrontRing(selectedSound2.value, "play")
            .then(() => {
            }).catch(failure);
    };

    const onChange = useCallback(
        (newSound: SoundState) => {
            rpc
                .updateSoundState(newSound)
                .then(() => dispatch(setSoundStateAction(newSound)))
                .catch(failure);
        },
        [dispatch, failure, rpc]
    );

    const onIntercomChange = useCallback(
        (value: number) => {
            onChange({...sound, intercom_level: value});
        },
        [onChange, sound]
    );

    const onAlarmChange = useCallback(
        (value: number) => {
            onChange({...sound, alarm_level: value});
        },
        [onChange, sound]
    );

    const onIncomingCallFlatFrontChange = useCallback(
        (value: number) => {
            onChange({...sound, incoming_call_flat_front_level: value});
        },
        [onChange, sound]
    );

    const onIncomingCallOutsidePanelChange = useCallback(
        (value: number) => {
            onChange({...sound, incoming_call_outside_panel_level: value});
        },
        [onChange, sound]
    );

    const onMicrophoneLevelChange = useCallback(
        (value: number) => {
            onChange({...sound, microphone_level: value});
        },
        [onChange, sound]
    );

    return (
        <PasswordContainer requiredRole="default" isFullscreen={true}>
            <SettingsPageContainer
                buttons={[]}
                className="service-edit"
                backUrl={"/settings"}
            >
                <div className="content-divider">
                    <div className="content-wrapper">
                        <RangeComponent
                            columnProps={{min: 12}}
                            name={t("incoming_call_outer_panel")}
                            value={sound.incoming_call_outside_panel_level}
                            onChange={onIncomingCallOutsidePanelChange}
                            activeImage={iconSound}
                            passiveImage={iconSoundOff}
                        />
                        <RangeComponent
                            columnProps={{min: 12}}
                            name={t("incoming_call_flat_front")}
                            value={sound.incoming_call_flat_front_level}
                            onChange={onIncomingCallFlatFrontChange}
                            activeImage={iconSound}
                            passiveImage={iconSoundOff}
                        />
                        <RangeComponent
                            columnProps={{min: 12}}
                            name={t("intercom_call_voice")}
                            value={sound.intercom_level}
                            onChange={onIntercomChange}
                            activeImage={iconSound}
                            passiveImage={iconSoundOff}
                        />
                        <RangeComponent
                            columnProps={{min: 12}}
                            name={t("alarm_ring_volume")}
                            value={sound.alarm_level}
                            onChange={onAlarmChange}
                            activeImage={iconSound}
                            passiveImage={iconSoundOff}
                        />
                    </div>
                    <div className="content-wrapper">
                        <div className="content-select-wrapper">
                            <div className="ring-tone-container">
                                {t("incoming_call_outer_panel_ring")}
                            </div>
                            <div className="ring-tone-select-container">
                                <div
                                    className="ring-tone-play-container"
                                    onClick={handlerSipPlay}
                                >
                                    <img src={playSound} alt={playSound}/>
                                </div>
                                <SettingSelectComponent
                                    label={t("")}
                                    options={incoming_call_flat_front}
                                    value={selectedSound}
                                    onChange={setSelectedSound}
                                />
                                <div
                                    className="ring-tone-save-container"
                                    onClick={handlerSipSave}
                                >
                                    <img src={saveSound} alt={saveSound}/>
                                </div>
                            </div>
                        </div>
                        <div className="content-select-wrapper">
                            <div className="ring-tone-container">
                                {t("incoming_call_flat_front_ring")}
                            </div>
                            <div className="ring-tone-select-container">
                                <div
                                    className="ring-tone-play-container"
                                    onClick={handlerBellPlay}>
                                    <img src={playSound} alt={playSound}/>
                                </div>
                                <SettingSelectComponent
                                    label={t("")}
                                    options={incoming_call_outer_panel}
                                    value={selectedSound2}
                                    onChange={setSelectedSound2}
                                />
                                <div
                                    className="ring-tone-save-container"
                                    onClick={handlerBellSave}
                                >
                                    <img src={saveSound} alt={saveSound}/>
                                </div>
                            </div>
                        </div>
                        <RangeComponent
                            columnProps={{min: 12}}
                            name={t("microphone_level")}
                            value={sound.microphone_level}
                            onChange={onMicrophoneLevelChange}
                            activeImage={microphoneOn}
                            passiveImage={microphoneOff}
                        />
                        <div className="click-voices-container">
                            <div className="click-voices-title">{t('click_sound')}</div>
                            <div className="click-voices-checkbox">
                                <SettingCheckBoxComponent
                                    label={t('')}
                                    set={setSoundReverseCheckbox}
                                    value={sound.click_sound}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    );
});
